import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RootState } from '../reducers';
import { ssoLoginCallback } from '../actions/authActions';
import { ReactComponent as Titan } from '../assets/titan.svg';
import { FormattedMessage } from 'react-intl';

interface SsoCallbackState {
  inProgress: boolean;
  success: boolean;
  error: string;
}

interface Props {
  location: any;
  history: any;
  token: string;
  ssoCallbackState: SsoCallbackState;
  ssoLoginCallback: (code: string, state: string) => void;
}

interface State {
  paramError: string;
  callbackStarted: boolean;
}

class OAuthCallback extends React.Component<Props, State> {
  state: State = { paramError: '', callbackStarted: false };

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const error = params.get('error');
    const errorDescription = params.get('error_description');
    const code = params.get('code');
    const stateParam = params.get('state');

    if (error) {
      this.setState({ paramError: errorDescription || error });
      return;
    }
    if (!code || !stateParam) {
      this.setState({ paramError: 'missing_params' });
      return;
    }
    this.setState({ callbackStarted: true });
    this.props.ssoLoginCallback(code, stateParam);
  }

  componentDidUpdate() {
    if (this.props.ssoCallbackState.success && this.props.token) {
      this.props.history.replace('/');
    }
  }

  render() {
    const { inProgress, success, error } = this.props.ssoCallbackState;
    // The callback can reject with an empty message (e.g. handleResponse's
    // TOKEN_ERROR branch returns exception('')). Detect the failed state from the
    // flags, not from the message, so we never strand the user on the loader.
    const hasCallbackError =
      this.state.callbackStarted && !inProgress && !success;
    if (this.state.paramError || hasCallbackError) {
      const errorText = this.state.paramError || error;
      return (
        <div className="table-body">
          <div className="login-logo">
            <Titan />
          </div>
          <div className="login-layout">
            <div className="sso-callback-error-heading">
              <FormattedMessage id="sso-login-failed" />
            </div>
            <div className="sso-callback-error-detail">
              {errorText || <FormattedMessage id="sso-login-failed-detail" />}
            </div>
            <span
              className="forgot-password-link sso-back-to-login-link"
              onClick={() => this.props.history.replace('/')}
            >
              <FormattedMessage id="sso-back-to-login" />
            </span>
          </div>
        </div>
      );
    }
    return <div className="log-loader"></div>;
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    token: state.auth.token,
    ssoCallbackState: state.auth.ssoCallbackState,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    ...bindActionCreators({ ssoLoginCallback }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OAuthCallback);
